<app-page headline="Product Catalog">
  <div stack-layout gap="md">
    <app-card headline="Product Catalog Data">
      <div ngProjectAs="header-content">
        <app-download-button
          mode="text"
          [blobObservable]="productService.downloadProducts()"
          [downloadFileName]="getProductCatalogFileName()"
          noContentMessage="No product catalog data found."
        />
      </div>
    </app-card>
    <app-card
      headline="Product Catalog"
      [loading]="productService.productFileUploading()"
      [loadingError]="productService.productFileUploadError()"
      [loadingProgress]="productService.productFileUploadProgress()"
      [loadingMessage]="
        productService.productFileUploadError()
          ? 'Errors found. Processing...'
          : 'Uploading Product Catalog...'
      "
    >
      <div ngProjectAs="header-content">
        <app-select
          [options]="entities.businessEntityOptions()"
          [form]="uploadForm"
          controlName="entityCode"
          placeholder="...select a business entity"
        />
      </div>
      <oui-file-drop-zone
        #fileDropZone
        [height]="160"
        (fileAttached)="handleFileAttached($event)"
        (fileRemoved)="selectedFile.set(undefined)"
        [allowedFileExtensions]="['xlsx', 'xls']"
        style="width: 100%"
        [helpTemplate]="fileDropZoneContent"
      />
      <ng-template #fileDropZoneContent>
        <div stack-layout [fullWidth]="true" alignItems="center" gap="sm">
          <Text role="title-small" align="center">
            Drag and drop the file here or
            <a
              href="javascript:void(0)"
              (click)="fileDropZone.openFileSelector()"
              >Choose File</a
            >
          </Text>
          <Text role="title-small" align="center" color="on-background-variant">
            Please ensure the uploaded file contains all of the existing fields.
          </Text>
        </div>
      </ng-template>
      <div row-layout justifyContent="center" gap="xl">
        <button
          text-button
          size="md"
          variant="secondary"
          (click)="fileDropZone.openFileSelector()"
        >
          Browse Files
        </button>
        <button
          text-button
          variant="success"
          size="md"
          (click)="uploadFile(selectedFile())"
          [disable]="!selectedFile() || uploadForm.invalid"
        >
          Upload
        </button>
      </div>
    </app-card>
  </div>

  <div box-layout paddingVertical="md" [grow]="1">
    @if (productService.noDataImportHistory()) {
      <div center-layout [grow]="1" [fullWidth]="true">
        <Text role="title-large">No product import history.</Text>
      </div>
    }
    <app-log-table
      [datasource]="dataImportHistoryDatasource"
      label="Upload History"
      [loading]="productService.dataSyncHistory.isLoading()"
      (reload)="productService.dataSyncHistory.reload()"
      [heightOffset]="670"
    />
  </div>
</app-page>

<app-validation-errors-dialog
  dialogTitle="Product Catalog Upload"
  [errors]="validationErrors()"
/>
